import React from 'react'
import { _ } from 'utils'
import TextField from '../../forms/components/TextField'

const SocialMedia = () => (
    <>
        <TextField
            name="website"
            label={_('speaker.form.website')}
            placeholder={_('speaker.form.website.placeholder', {}, false)}
            lg={1/2}
        />
        <TextField
            name="twitter"
            label={_('speaker.form.twitter')}
            placeholder={_('speaker.form.twitter.placeholder', {}, false)}
            lg={1/2}
        />
        <TextField
            name="facebook"
            label={_('speaker.form.facebook')}
            placeholder={_('speaker.form.facebook.placeholder', {}, false)}
            lg={1/2}
        />
        <TextField
            name="linkedin"
            label={_('speaker.form.linkedin')}
            placeholder={_('speaker.form.linkedin.placeholder', {}, false)}
            lg={1/2}
        />
        <TextField
            name="instagram"
            label={_('speaker.form.instagram')}
            placeholder={_('speaker.form.instagram.placeholder', {}, false)}
            lg={1/2}
        />
        <TextField
            name="googlePlus"
            label={_('speaker.form.youtube')}
            placeholder={_('speaker.form.youtube.placeholder', {}, false)}
            lg={1/2}
        />
    </>
)

export default SocialMedia
